// Module
var code = `<div class="deck-funds">
  <div class="deck-funds-bar">
    {{#fundSegments}}
    <div class="deck-funds-segment deck-funds-segment--{{attrTier}}" style="--deck-funds-share: {{attrShare}}">
      <span class="deck-funds-share">{{share}}</span>
    </div>
    {{/fundSegments}}
  </div>
  <ul class="deck-funds-labels">
    {{#fundSegments}}
    <li class="deck-funds-label deck-funds-label--{{attrTier}}" style="--deck-funds-share: {{attrShare}}">{{label}}</li>
    {{/fundSegments}}
  </ul>
</div>
{{#fundsFallback}}
<figcaption class="deck-exhibit-caption">{{.}}</figcaption>
{{/fundsFallback}}
`;
// Exports
module.exports = code;